import { ReactNode } from 'react'

import styled from 'styled-components'

import { Box } from '@themenu/design-system'

import { GradientBackground, LaptopImage, MobileImage, SwileLogo } from './Images'
import { useIsMobile } from '../../hooks/useIsMobile'
import { HelpButton } from '../../pages/signin/HelpButton'
import { LegalLinks } from '../../pages/signin/LegalLinks'

export const StyledRootContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  flex: 1;
  z-index: 1;
`

export const CenterHorizontally = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
`
export const StyledContent = styled(Box)`
  display: flex;
  flex-direction: column;
  max-width: 350px;
  margin: auto;
`

const ImgContainer = styled.div`
  position: relative;
  display: flex;
  max-height: 320px;
  min-height: 40px;
  flex: 1;
`

const SwileLogoMobile = styled.div`
  position: absolute;
  bottom: -40px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
`

const MainSection = styled(Box)`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
`

const StyledContainer = styled.main<{ gridTemplateColumns: string }>`
  height: 100%;

  display: grid;
  justify-content: center;
  grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};
`

const RightLayout = styled.div`
  position: relative;
  z-index: 0;
`

export const Layout = ({ children }: { children?: ReactNode }): JSX.Element => {
  const isMobileScreen = useIsMobile()

  const getGridTemplateColumns = (): string => {
    if (isMobileScreen) return '100% 0'
    return '50% 50%'
  }

  return (
    <StyledContainer gridTemplateColumns={getGridTemplateColumns()} data-testid="layout">
      <Box display="flex">
        <StyledRootContainer>
          {isMobileScreen && (
            <ImgContainer>
              <MobileImage />
              <SwileLogoMobile>
                <SwileLogo />
              </SwileLogoMobile>
            </ImgContainer>
          )}
          <MainSection>
            <GradientBackground />
            <StyledContent>
              <Box mt={isMobileScreen ? 60 : 0} mb={isMobileScreen ? 20 : 0}>
                {!isMobileScreen && (
                  <Box display="flex" flexGrow={1} flexDirection="column" justifyContent="flex-end">
                    <SwileLogo />
                  </Box>
                )}
                {children}
              </Box>
            </StyledContent>
            <HelpButton />
            <LegalLinks />
          </MainSection>
        </StyledRootContainer>
      </Box>
      {!isMobileScreen && (
        <RightLayout data-testid="layout-right-column">
          <LaptopImage />
        </RightLayout>
      )}
    </StyledContainer>
  )
}
